import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ROUTE, ROUTE_LABEL } from "../../shared/enums";
import "./Navbar.scss";
import useAuth from "../../shared/hooks/useAuth";
import MyProfilePopup from "../MyProfile/MyProfilePopup/MyProfilePopup";
import { useEffect, useState } from "react";
import Dropdown from "../../components/UI/Dropdown/Dropdown";
import KLTKVolleyLogo from "../../assets/images/KLTK-volley.svg";

import HandleDailyCommentPopup from "../DailyComment/HandleDailyCommentPopup";
import React from "react";
interface INavbarProps {
  isAdmin?: boolean;
  isCoach?: boolean;
}

function Navbar(props: INavbarProps) {
  const navigate = useNavigate();
  const { isAdmin, isCoach } = props;
  const [showMyProfilePopup, setShowMyProfilePopup] = useState(false);
  const { userInfo, isLoading, signOut } = useAuth();

  const RouteIsPreview = useLocation().pathname.includes("visual-art-preview");

  const [showHandleDailyCommentPopup, setShowHandleDailyCommentPopup] =
    useState<boolean>(false);

  let navItems = [];
  const navItemsAdmin = [
    {
      label: ROUTE_LABEL.Bookings,
      path: ROUTE.Bookings,
    },
    {
      label: ROUTE_LABEL.Users,
      path: ROUTE.Users,
    },
    {
      label: ROUTE_LABEL.Coach,
      path: ROUTE.Coach,
    },
    {
      label: ROUTE_LABEL.Activities,
      path: ROUTE.Activities,
    },
    {
      label: ROUTE_LABEL.Statistics,
      path: ROUTE.Statistics,
    },
    {
      label: ROUTE_LABEL.Settings,
      path: ROUTE.Settings,
    },
  ];

  const navItemsUser = [
    {
      label: ROUTE_LABEL.Bookings,
      path: ROUTE.Bookings,
    },
    {
      label: ROUTE_LABEL.Users,
      path: ROUTE.Users,
    },
    {
      label: ROUTE_LABEL.MyProfile,
      path: ROUTE.MyProfile,
    },
  ];

  const navItemsCoach = [
    {
      label: ROUTE_LABEL.Coach,
      path: ROUTE.Coach,
    },
  ];

  navItems = isAdmin ? navItemsAdmin : isCoach ? navItemsCoach : navItemsUser;
  const location = useLocation();

  const [settingsDropdownValue, setSettingsDropdownValue] = useState(
    location.pathname,
  );

  useEffect(() => {
    if (
      location.pathname === ROUTE.Admin ||
      location.pathname === ROUTE.Integrations ||
      location.pathname === ROUTE.Memberships ||
      location.pathname === ROUTE.Facility ||
      location.pathname === ROUTE.Tracks
    ) {
      setSettingsDropdownValue(location.pathname);
    }
  }, [location.pathname]);

  const handleNavLinkClick = (path: any) => {
    if (path === "Kommentar") {
      setShowHandleDailyCommentPopup(true);
      return;
    }
    if (
      path === ROUTE.Admin ||
      path === ROUTE.Integrations ||
      path === ROUTE.Memberships ||
      path === ROUTE.Facility ||
      path === ROUTE.Tracks ||
      path === ROUTE.EmailTemplates
    ) {
      setSettingsDropdownValue(path);
      navigate(path);
    } else {
      setSettingsDropdownValue("");
    }
  };

  if (RouteIsPreview) {
    return null;
  }
  return (
    <>
      <nav className={`navbar`}>
        <div className="nav-items--wrapper">
          <img
            src={KLTKVolleyLogo}
            alt="KLTK volley logo"
            className="pointe kltk-logo-nav"
          />
          <div className="nav-items">
            {navItems.map((navItem) => {
              if (navItem.label === ROUTE_LABEL.MyProfile) {
                return (
                  <div
                    key={navItem.label}
                    className="nav-item text-m pointer my-profile-hover"
                    onClick={() => setShowMyProfilePopup(true)}
                  >
                    {navItem.label}
                  </div>
                );
              }

              if (navItem.label === ROUTE_LABEL.Statistics && isAdmin) {
                return (
                  <React.Fragment key={navItem.label}>
                    <NavLink
                      to={navItem.path}
                      className="nav-item text-m"
                      onClick={() => handleNavLinkClick("test")}
                    >
                      {navItem.label}
                    </NavLink>
                    <div className="nav-divider" />
                  </React.Fragment>
                );
              }

              if (navItem.label === ROUTE_LABEL.Settings) {
                return (
                  <React.Fragment key={navItem.label}>
                    <Dropdown
                      title={navItem.label}
                      classes={"nav-dropdown text-m"}
                      short
                      width={120}
                      options={[
                        {
                          value: ROUTE.Admin,
                          label: ROUTE_LABEL.Admin,
                        },
                        {
                          value: ROUTE.Integrations,
                          label: ROUTE_LABEL.Integrations,
                        },
                        {
                          value: ROUTE.Memberships,
                          label: ROUTE_LABEL.Memberships,
                        },
                        {
                          value: ROUTE.Facility,
                          label: ROUTE_LABEL.Facility,
                        },
                        {
                          value: ROUTE.Tracks,
                          label: ROUTE_LABEL.Tracks,
                        },
                        { value: "Kommentar", label: "Kommentar" },
                        {
                          value: ROUTE.EmailTemplates,
                          label: ROUTE_LABEL.EmailTemplates,
                        },
                      ]}
                      onSelect={(value) => {
                        handleNavLinkClick(value);
                      }}
                      value={settingsDropdownValue}
                    />
                  </React.Fragment>
                );
              }
              return (
                <NavLink
                  key={navItem.label}
                  to={navItem.path}
                  className="nav-item text-m"
                  onClick={() => handleNavLinkClick("test")}
                >
                  {navItem.label}
                </NavLink>
              );
            })}
            {(isAdmin || isCoach) && (
              <>
                <div className="nav-divider" />
                <header className="App-header">
                  <div className="sign-out text-m pointer" onClick={signOut}>
                    Logga ut
                  </div>
                </header>
              </>
            )}
          </div>
        </div>
        {!isCoach && !isAdmin && (
          <MyProfilePopup
            showPopup={showMyProfilePopup}
            onClose={() => {
              setShowMyProfilePopup(false);
            }}
            user={userInfo}
            onSignOut={signOut}
          />
        )}
        <HandleDailyCommentPopup
          showPopup={showHandleDailyCommentPopup}
          onClose={() => setShowHandleDailyCommentPopup(false)}
          onConfirm={() => window.location.reload()}
        />
      </nav>
    </>
  );
}

export default Navbar;
